// import { DialogConfig } from '@angular/cdk/dialog';
import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { newmetadate, style } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { CryptoRepository } from '../interfaces/crypto-repository';
import { DatosCompartidosService } from '../services/datos-compartidos.service';

@Component({
  selector: 'app-dialog-table',
  templateUrl: './dialog-table.component.html',
  styleUrls: ['./dialog-table.component.css'],
  standalone: false
})
export class DialogTableComponent {
  @Output() onDataSelect = new EventEmitter<any>();
  puertosFavoritos: any[] = [];
  estilos: style = {
    header: {
      align: 'left',
      justify: 'center',
      size: '10px'
    },
    body: {
      size: '9px'
    }
  }
  constructor(public readonly data: DynamicDialogConfig, public readonly ref: DynamicDialogRef, private datosCompartidosService: DatosCompartidosService) {

  }

  serviciosytarifas_NaveViajePorPuerto: any[] = []
  fila: any
  key: any
  row: any;
  dataRow: any

  ngOnInit() {
    let dataItinerarios = this.data.data.data.data;
    if (this.data.data.data.data) {

      this.puertosFavoritos = this.datosCompartidosService.getlistaDatos();
      if (this.puertosFavoritos != null) {

        this.serviciosytarifas_NaveViajePorPuerto = dataItinerarios.map(item => {
          const newItem = { ...item };
          if (item.puerto) {
            newItem.codPuerto = item.puerto;
            const puertoEncontrado = this.puertosFavoritos.find(puerto => puerto.codigo === item.puerto);
            newItem.valuePuerto = puertoEncontrado ? puertoEncontrado.value : null;
            newItem.puerto = puertoEncontrado ? puertoEncontrado.label : item.puerto;
          }
          newItem.puertoOrigen = this.data.data.data.puertoOrigen;
          return newItem; 
        });
        // console.log("Data con puertos actualizados:", this.serviciosytarifas_NaveViajePorPuerto);
      }
    }
  }

  metadatableNaveViajePorPuerto: newmetadate[] = [
    { field: "seleccionar", title: "", inputType: 'buttonPersonalizado', icon: 'pi pi-chevron-down', function: (rowdata: any) => this.close(rowdata), style: { justify: "center" } },
    { title: 'Cód. Viaje', field: 'codigoviaje', filterType: 'text', inputType: 'text' },
    { title: 'Nombre Nave', field: 'nombrenave', filterType: 'text', inputType: 'text' },
    { title: 'Viaje Vuelo', field: 'viaje_vuelo', filterType: 'text', inputType: 'text' },
    { title: 'Transportista', field: 'transportista', filterType: 'text', inputType: 'text', style: { width: '10%', align: 'center', justify: 'left' }, maxWidth: '148px' },
    { title: 'Puerto', field: 'puerto', filterType: 'text', inputType: 'text', style: { width: '10%', align: 'center', justify: 'left' }, maxWidth: '168px' },
    { title: 'ETA_ETD', field: 'eta_etd', filterType: 'text', inputType: 'date' },
    { title: 'Fec. Cierre Direccionamiento', field: 'fechacierredireccionamiento', filterType: 'text', inputType: 'date' },
    { title: 'Fec. Nave Entregada', field: 'fechanaveentregada', filterType: 'text', inputType: 'date' },
    { title: 'Estado', field: 'estado', filterType: 'text', inputType: 'text' },
    { title: 'Feeder', field: 'feeder', filterType: 'boolean', inputType: 'checkbox' },
  ]

  close(row) {
    row = row.row
    console.log(row)
    if (row) {
      const selectedData = {
        nvia_esfeeder: row['feeder'],
        codigoviaje: row['codigoviaje'],
        nombrenave: row['nombrenave'],
        viaje_vuelo: row['viaje_vuelo'] || null,
        eta_etd: row['eta_etd'] != null ? new Date(row['eta_etd']) : null,
        puerto: {
          label: row['puerto'] || null,
          value: row['valuePuerto'] || null
        },
        puertoOrigen: row['puertoOrigen'] || null,
        valuePuerto: row['valuePuerto'] || null,
        codPuerto: row['codPuerto'] || null
      };

      this.ref.close(selectedData);
      this.onDataSelect.emit(selectedData);
      console.log("Datos en el row: ", row);

      // console.log("Nueva NAVE:", this.fila["nombrenave"])
      // // Aquí asignas el valor de `key`
      // this.key = 13398; // Asegúrate de que este valor es el identificador correcto

      // // Encuentra la fila correspondiente usando `this.key`
      // const rowIndex = this.serviciosytarifas_NaveViajePorPuerto.findIndex(row => row.codigoviaje === this.key);

      // if (rowIndex > -1) {
      //   this.serviciosytarifas_NaveViajePorPuerto[rowIndex].nombrenave = nombreNaveValue;
      //   console.log(`Fila con codigoviaje ${this.key} actualizada con el nuevo nombre de nave: ${nombreNaveValue}`);
      // } else {
      //   console.log(`No se encontró una fila con codigoviaje ${this.key}`);
      // }
    }
  }


}
